import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SuggestedQuestionService {
  private _suggestion = new Subject<{text: string, autoSend: boolean}>();
  
  suggestionQuestion = this._suggestion.asObservable();

  updateSuggestion(suggestion: {text: string, autoSend: boolean}) {
    this._suggestion.next(suggestion);
  }
}
